<template>
  <div class="h-screen text-red-500 text-2xl md:text-5xl grid">
    <p class="place-self-center">404 Page not found</p>
  </div>
</template>
<script setup></script>
